import { Injectable } from '@angular/core';
import { SeuLocalStorageKey } from '@seu-types';
import { isNil } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  public getItem<T = string>(key: SeuLocalStorageKey): T | null {
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item) as T;
    }
    return null;
  }

  public setItem<T>(key: SeuLocalStorageKey, value: T): void {
    if (isNil(value)) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }
}
